module.exports = __webpack_public_path__ + "vue/img/footer_bot.a4c7ace5.svg";